export const Escalate = "Escalate";
export const EscalationReason = "Escalation Reason";
export const ThirdPartyType = "Third Party Type";
export const TypeOfProperty = "Type of Property";
export const WhyNot = "Why not";
export const ThirdPartyTitle = "Third Party Title";
export const TPSustainedInjuries = "Has this Third Party Sustained Injuries";
export const TypeOfInjury = "Type of Injury";
export const VehicleType = "Vehicle Type";
export const NoContactDetailsTP = "Why are there no contact details for the third party";
export const FinishTimeOfCall = "Finish Time of Call";
export const DateOfCall = "Date of call";
export const FnolComplete = "FNOL Complete";
export const ReasonForLateReporting = "Reason for late reporting";
export const ReasonForUpdatedFnol = "Reason for updated fnol";
export const ThirdParties = "thirdParties";
export const Passengers = "passengers";

export const TPAreTPDetailsKnown = "TP - Are Third Party Details Known";
export const TPWhyNoContactDetailsTP = "TP - Why Are There No Contact Details For The Third Party";
export const TPThirdPartyType = "TP - Third Party Type";
export const TPTypeOfProperty = "TP - Type Of Property";
export const TPBumpCardGivenToTP = "TP - Has The Bump Card Been Given To The Third Party";
export const TPAreYouAbleTo = "TP - Are You Able To";
export const TPLeaveBumpCardVehicle = "TP - Can You Leave The Bump Card On The Vehicle";
export const TPLeaveBumpCardReturnVehicle = "TP - Can You Return To The Vehicle To Leave The Bump Card";
export const TPWhyNot = "TP - Why Not";
export const TPThirdPartyTitle = "TP - Third Party Title";
export const TPHasTPSustainedInjuries = "TP - Has This Third Party Sustained Injuries";
export const TPTypeOfInjury = "TP - Type Of Injury";
export const TPDidTPAdmitLiability = "TP - Did Third Party Admit Liability";
export const TPIsDriverOwnerOfVehicle = "TP - Is Driver The Owner Of The Vehicle";
export const TPVehicleType = "TP - Vehicle Type";
export const TPIsVehicleDriveable = "TP - Is Vehicle Driveable";
export const TPIsTherePreExistingDamageToTPVehicle = "TP - Is There Pre Existing Damage To The Third Party Vehicle";
export const Country = "Country";
export const CustomerRequireChangeOver = "Customer Require Change Over";
export const RentalStation = "Rental Station";
export const AirportRentalStation = "Airport Rental Station";
export const CurrentVehicleLocation = "Current vehicle location";
export const RepairStationName = "Repair Station Name";
export const RecoverVehicleTo = "Recover vehicle to";

export const VehicleRegistration = "Vehicle registration";
export const IncidentDate = "Incident date & time";
export const DriverForname = "Driver Forename";
export const DriverSurname = "Driver Surname";
export const PayrollNumber = "Payroll Number";
export const ReportedBy = "Incident Reported By";
export const StartTimeOfCall = "Start Time of Call";
